var map = {
	"./symbol_0.png": 77809,
	"./symbol_1.png": 63592,
	"./symbol_10.png": 77434,
	"./symbol_2.png": 65219,
	"./symbol_3.png": 47642,
	"./symbol_4.png": 4149,
	"./symbol_5.png": 35052,
	"./symbol_6.png": 55111,
	"./symbol_7.png": 36798,
	"./symbol_8.png": 65705,
	"./symbol_9.png": 10880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 75756;